import React from "react"
import { trans } from "@/_providers/Translation"
import "@/assets/css/analytics.css"

// components
import RepairRequests from "./partials/RepairRequests"
import TechniciansWorkload from "./partials/TechniciansWorkload"
import InventoryLevel from "./partials/InventoryLevel"
import ClientGrowth from "./partials/ClientGrowth"
import PartsUsage from "./partials/PartsUsage"
import DeviceUsage from "./partials/DeviceUsage"
import IncomesAndExpenses from "./partials/IncomesAndExpenses"
import IncomesByCategory from "./partials/IncomesByCategory"
import ExpensesByCategory from "./partials/ExpensesByCategory"
import OrdersInTime from "./partials/OrdersInTime"

// providers
import { useAuthDataContext } from "@/_providers/Auth"

function Trends() {
  const { access, permission } = useAuthDataContext()

  function hasPermisson(item) {
    if (access(item) || permission(item)) {
      return true
    }

    return false
  }

  return (
    <div id="analytics-trends">
      <div className="top-part">
        <div className="left">
          <h1 className="page-heading">{trans("nav.analytics_trends")}</h1>
          <p className="page-subheading">
            {trans("subheadings.analytics_trends")}
          </p>
        </div>
      </div>
      <div className="row">
        <div className="col">
          <div className="pannel">
            <RepairRequests />
          </div>
        </div>
      </div>
      {hasPermisson("analytics.technicians") && (
        <div className="row">
          <div className="col">
            <div className="pannel">
              <TechniciansWorkload />
            </div>
          </div>
        </div>
      )}
      <div className="row">
        {hasPermisson("analytics.realtime") && (
          <div className="col">
            <div className="pannel">
              <InventoryLevel />
            </div>
          </div>
        )}
        <div className="col">
          <div className="pannel">
            <ClientGrowth />
          </div>
        </div>
      </div>
      {hasPermisson("parts") && (
        <div className="row">
          <div className="col">
            <div className="pannel">
              <PartsUsage />
            </div>
          </div>

          <div className="col">
            <div className="pannel">
              <DeviceUsage />
            </div>
          </div>
        </div>
      )}
      {hasPermisson("parts") && hasPermisson("analytics.technicians") && (
        <div className="row">
          <div className="col">
            <div className="pannel">
              <OrdersInTime />
            </div>
          </div>
        </div>
      )}
      {hasPermisson("accounts") && (
        <>
          <div className="row">
            <div className="col">
              <div className="pannel">
                <IncomesAndExpenses />
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col">
              <div className="pannel">
                <IncomesByCategory />
              </div>
            </div>
            <div className="col">
              <div className="pannel">
                <ExpensesByCategory />
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  )
}

export default Trends
